module.exports = __webpack_public_path__ + "static/alm-print-0684096cd187d340cfa62c25a27cff2e.mp4";